import { scaleLinear } from 'd3-scale';
import { axisLeft, axisBottom } from 'd3-axis';
import { randomNormal } from 'd3-random';
import { select, selectAll } from 'd3-selection';
import { range } from 'd3-array';

export default Object.assign({}, {
    select,
    selectAll,
    scaleLinear,
    axisLeft,
    axisBottom,
    randomNormal,
    range,
});
